import { tokens } from '@veneer/tokens';
import { MainTheme } from '@uma/react-commons/dist/index';
import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${tokens.layout.size1};

  && {
    h4 {
      font-size: ${tokens.typography.size7};

      @media (${MainTheme.mediaQueries.maxWidthMobile}) {
        font-size: ${tokens.typography.size6};
      }
    }

    p.body {
      font-size: ${tokens.typography.size2};
    }
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${tokens.layout.size6};
  overflow: hidden;

  @media (${MainTheme.mediaQueries.mobile}) {
    gap: ${tokens.layout.size6};
  }

  @media (${MainTheme.mediaQueries.maxWidthMobile}) {
    gap: ${tokens.layout.size5};
  }
`;

export const DrillDownHeader = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;

  svg {
    cursor: pointer;
    &:focus-visible {
      position: relative;
      outline: #001cb0 solid 2px;
      outline-offset: 0;
      border-radius: ${tokens.layout.size1};
    }
  }

  .subtitle-regular {
    font-size: ${tokens.typography.size4};
  }
`;

export const ErrorAndLoading = styled.div`
  display: flex;
  justify-content: center;
`;
